module.exports = __webpack_public_path__ + "img/ico_list_arrow_down.5bda0f25.svg";